import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

function formatCurrency(value) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value || 0);
}

function formatCompact(value) {
  if (value >= 1000000) return `$${(value / 1000000).toFixed(1)}M`;
  if (value >= 1000) return `$${(value / 1000).toFixed(0)}K`;
  return formatCurrency(value);
}

export default function AgingBuckets({ agingBuckets, pastDueTotal }) {
  if (!agingBuckets || pastDueTotal === 0) {
    return null;
  }

  const buckets = [
    { key: "1-7", label: "1-7d", fullLabel: "1-7 days", color: "bg-yellow-500" },
    { key: "8-30", label: "8-30d", fullLabel: "8-30 days", color: "bg-orange-500" },
    { key: "31-60", label: "31-60d", fullLabel: "31-60 days", color: "bg-red-500" },
    { key: "60+", label: "60+d", fullLabel: "60+ days", color: "bg-red-700" }
  ];

  return (
    <Card className="mb-4 sm:mb-6">
      <CardHeader className="pb-2 sm:pb-3 px-3 sm:px-6">
        <CardTitle className="text-sm sm:text-base font-semibold" style={{ fontFamily: 'var(--font-sans)' }}>
          Aging Summary
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0 px-3 sm:px-6">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-4">
          {buckets.map((bucket) => {
            const amount = agingBuckets[bucket.key] || 0;
            const percentage = pastDueTotal > 0 ? (amount / pastDueTotal) * 100 : 0;
            
            return (
              <div key={bucket.key} className="p-2 sm:p-3 bg-secondary/30 rounded-lg">
                <div className="flex items-center justify-between mb-1 sm:mb-2">
                  <span className="text-[10px] sm:text-xs text-muted-foreground">
                    <span className="hidden sm:inline">{bucket.fullLabel}</span>
                    <span className="sm:hidden">{bucket.label}</span>
                  </span>
                </div>
                <p className="font-bold text-sm sm:text-base">
                  <span className="hidden sm:inline">{formatCurrency(amount)}</span>
                  <span className="sm:hidden">{formatCompact(amount)}</span>
                </p>
                <div className="mt-1 sm:mt-2 h-1.5 sm:h-2 bg-secondary rounded-full overflow-hidden">
                  <div 
                    className={`h-full ${bucket.color} transition-all`} 
                    style={{ width: `${Math.min(percentage, 100)}%` }}
                  />
                </div>
                <p className="text-[10px] text-muted-foreground mt-0.5">{Math.round(percentage)}%</p>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
